import { useEffect, useState, useContext } from "react";
import copy from "copy-to-clipboard";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/Auth";
import ActionDialog from "../../components/ActionDialog";
import { isSubscriptionAccessBlocked } from "../../utils/subscriptionStatus";

const InterviewsCard = ({ interviews, subscriptionStatus }) => {
  const navigate = useNavigate();

  const { currentUser } = useContext(AuthContext);
  const [dialog, setDialog] = useState(false);
  const [loading, setLoading] = useState();

  const onCreateInterview = () =>{
    if(isSubscriptionAccessBlocked(subscriptionStatus)){
      setDialog(true);
    }else{
      navigate("/create");
    }
  }

  const upgradeSubscription = async () => {
    window.location.href = `https://buy.stripe.com/8wMaHbcgp0Du0SYdQS?client_reference_id=${currentUser.uid}`;

    // `https://buy.stripe.com/test_aEU6qEc8b2Q7digbIJ?client_reference_id=${currentUser.uid}`;
    // setLoading(true);
    // const response = await fetch(
    //   `${process.env.REACT_APP_SERVER_URL}/subscriptions`,
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       userId: currentUser.uid,
    //     }),
    //   }
    // );
    // const { newSubscription, url } = await response.json();

    // if (newSubscription) {
    //   setDialog(false);
    //   window.location.href = url;
    //   setLoading(false);
    // } else {
    //   setDialog(false);
    //   toast.success("Subscription renewed!");
    //   setLoading(false);
    // }
  };

  const closeDialog = () => {
    setDialog(false);
  };



  return (
    <div className="bg-white rounded-lg max-h-full shadow-sm relative mb-6">
      <ActionDialog
        title={"Subscribe PRO plan"}
        subtitle={
          "Subscribe the PRO plan to create unlimited new interviews or get more responses"
        }
        btnTitle={"Subscribe"}
        btnStyle={"bg-blue-600 hover:bg-blue-700"}
        isOpen={dialog}
        closeDialog={closeDialog}
        action={upgradeSubscription}
        loading={loading}
        loadingStyle={"bg-blue-300 pointer-events-none"}
        loadingText={"Subscribe"}
      />
      <div className="mb-6 flex flex-col space-y-1 px-6 pt-6">
        <span className="font-sans font-medium text-gray-900 text-sm">
          Share your interviews
        </span>

        <span className="font-sans font-normal text-gray-500 text-xs">
          Get a link to your interview in one click.
        </span>
      </div>

      {interviews.length > 0 ? (
        <div className="h-56 overflow-auto no-scrollbar z-50">
          {interviews &&
            interviews.map((interview) => (
              <div
                onClick={() => {
                  if (interview.live && subscriptionStatus !== "cancelled") {
                    {
                      copy(`https://app.usehaste.io/answer/${interview._id}`);
                      toast.success("Link copied!");
                    }
                  }
                }}
                className="mx-2"
              >
                <div
                  className={`${
                    interview.live && subscriptionStatus !== "cancelled"
                      ? "hover:bg-gray-100 cursor-pointer"
                      : "pointer-events-none"
                  } px-4 py-4 rounded-lg flex justify-between items-center `}
                >
                  <div className="flex space-x-4 items-center">
                    {interview.live && subscriptionStatus !== "cancelled" ? (
                      <div className="w-2 h-2 rounded-full bg-green-300 ring ring-green-100"></div>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3 w-3 text-gray-900 "
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                        />
                      </svg>
                    )}
                    <span className="w-40 font-sans font-medium text-gray-700 text-xs truncate">
                      {interview.title}
                    </span>
                  </div>
                  <div className="font-sans font-medium text-gray-400 text-xs">
                    {interview.answerSets.length}{" "}
                    {interview.answerSets.length === 1
                      ? "response"
                      : "responses"}
                  </div>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div className="mt-12 p-6 w-full flex flex-col items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            className="h-20"
            viewBox="0 0 475.03746 329.38439"
          >
            <path
              d="M434.78754,361.26747c26.75235,4.24589,52.12054-26.6503,42.74924-52.06476s-48.72467-32.44527-66.31637-11.848S406.53987,356.78426,434.78754,361.26747Z"
              transform="translate(-362.48127 -285.3078)"
              fill="#3373f0"
            />
            <path
              d="M801.34827,600.85624l-.001.00052-.04433.03429C801.31676,600.88153,801.33373,600.86681,801.34827,600.85624Z"
              transform="translate(-362.48127 -285.3078)"
            />
            <path
              d="M830.88131,381.44881c-4.566-2.91118-10.18815-3.47684-15.35227-4.77059-21.10413-4.01566-42.26662-8.6226-63.8035-9.35546-37.89458.263-75.78605,1.59161-113.6737,2.42733-19.85263.61978-39.71911.56843-59.56342-.3072-15.20992-.7242-30.38244-2.19468-45.6102-2.55219-24.60079-.63181-49.18444,1.043-73.66124,3.42116,7.07419-7.9901,11.72885-18.15841,12.1829-28.83577.84282-15.49418-6.21873-31.29981-18.7452-40.56461-6.04-4.60227-13.32271-7.21524-20.46253-9.59036-7.68324-2.0958-15.69931-3.88405-23.70291-3.4816a28.76546,28.76546,0,0,0-13.88482,4.89181c-6.21145,3.5784-9.42152,10.11152-12.85428,16.11214-1.411,2.34941.61805-.50219,1.38589-1.33982,2.86926-3.25942,5.59687-6.85279,9.31432-9.18748,5.1856-2.85264,10.35907-4.87423,16.99618-4.113a92.82506,92.82506,0,0,1,35.8316,14.78063c.243.19516.50219.41232.71762.61207a42.29552,42.29552,0,0,1,7.37291,8.194c12.80753,19.40334,7.14589,40.76783-10.13,52.5159a56.21488,56.21488,0,0,1-7.93122,4.101c-.0916-1.2547-.19724-2.50647-.34114-3.75027-.08815,1.341-.19153,2.68363-.29543,4.02639a47.83269,47.83269,0,0,1-13.02589,3.452c-.66446.18044-11.54356,1.39541-17.04779.73909-8.63394-.42288-20.72211-6.581-25.30282-13.24729-5.27339-7.89771-9.3-15.68-9.45183-21.12007.10789-5.47522,1.195-10.94585,3.63156-17.92922a27.44013,27.44013,0,0,1,1.46988-2.98832c3.18668-5.12022,8.36552-9.27,13.81468-12.14887,4.37481-2.17121,9.18185-3.25032,13.83253-4.66114-5.61662.76957-11.401,1.15781-16.68777,3.36184-6.37163,2.74173-12.61357,6.80665-16.35475,12.779-4.012,7.28208-7.05964,15.65453-7.06744,24.039.60021,7.28079,3.74534,14.04674,7.127,20.421,6.1583,12.03319,19.05345,19.43338,32.15779,21.33721,8.97422,1.352,18.12265.35137,27.01721-1.13348a43.53861,43.53861,0,0,0,4.86454-1.2561c-.82481,8.636-1.71543,17.29247-2.1823,25.93767-1.38865,22.75661-3.20608,45.48907-4.39316,68.25641-.72178,18.169-.92543,36.36765-2.29071,54.50572-1.10777,14.75639-3.71,32.186-4.993,42.853-3.56108,20.9301,10.44357,18.954,26.10287,20.16537a372.79741,372.79741,0,0,1,41.93413,5.22075,580.6301,580.6301,0,0,0,76.62506,10.09611c22.6005.92993,45.23857.41414,67.84738,1.27159q37.7667.37327,75.51261-1.65724c24.349-1.09479,48.68328-3.42211,73.073-3.05473,4.39646.10234,8.787.38271,13.16322.81373,3.24695.3079,6.6404.68844,9.74-.56809,12.93238-4.99381,15.18239-27.72332,17.67414-39.69832,3.67364-23.25526,8.84971-46.271,11.80816-69.63693,3.0388-29.05422,4.05011-58.29867,4.17722-87.50061C836.95994,400.7356,839.83094,387.978,830.88131,381.44881Zm-4.77657,65.49209c-.68385,19.10383-1.51662,38.24187-3.7365,57.23739-.72991,5.22274-4.20094,26.4422-6.18981,36.92136-2.49487,12.84156-4.14259,24.41767-5.711,34.11557-1.77535,9.71617-3.08053,17.95969-7.45656,23.92508-.31015.36339-.78013.9004-1.19435,1.30614-.15828.10606-.30773.2259-.47536.31759a7.12339,7.12339,0,0,1-.76524.40046c-.31344.09515-.61631.16893-.84126.22027-3.84422.22356-3.577-.21733-5.68762-.29526-27.85865-3.25456-55.90467.566-83.79588,1.63595-35.644,2.1803-71.365,2.32871-107.05165,1.35333-12.27139-.16486-24.5523.15239-36.815-.44852-12.33269-.42227-34.2334-2.9639-41.45063-3.927-27.45673-3.97348-50.667-9.39641-76.13862-11.14387-8.38337-.9017-16.17778-.36444-19.53937-2.27694-.054-.18512-.10286-.37093-.14338-.55951-.01628-.18347-.043-.36608-.04572-.55042a27.01013,27.01013,0,0,1,.21092-3.66741c.09906-.93954.21127-1.8776.33111-2.8148q.15948-1.24371.32486-2.48682-.08883.66161-.17784,1.323c1.86072-14.30363,3.77044-28.60977,4.8247-43.00094,1.01444-15.10256,1.30952-30.24443,1.68669-45.37331.50046-17.33758,1.68044-34.66122,1.20977-52.01482-.11291-14.49551-.83919-28.974-1.39732-43.45665-.1697-2.68008-.24867-5.37963-.31846-8.08144a91.60588,91.60588,0,0,0,12.19225-5.71827,51.51169,51.51169,0,0,0,8.85612-7.02969c.08624.00858.17231.01888.25855.02745,20.80558,2.13087,41.66848,3.6139,62.51684,5.24837,23.92162,1.83,47.8557,3.80811,71.84763,4.37481,39.21171.88127,78.40854-1.58979,117.61194-2.15675,18.87265-.22452,37.81285-1.92705,56.64.037,9.26618.55856,34.06525,5.42483,41.35106,6.605,5.78632,1.03928,11.68071,1.8137,17.27135,3.68282.125.07117.2414.15671.36262.23455.11048.10668.21023.22391.31447.33691a7.28671,7.28671,0,0,1,.44159.79c1.24925,3.71546,1.01928,10.15421,1.06846,17.53708C826.49888,422.02675,826.4833,434.48733,826.10474,446.9409Z"
              transform="translate(-362.48127 -285.3078)"
            />
            <path
              d="M746.50583,447.74086c-14.91553-2.66553-29.83245-5.39946-44.86228-7.34694-18.19659-2.12376-36.49553-3.22773-54.78772-4.13358-21.39834-.908-42.71773-3.57156-64.14188-3.72568-17.36225.0413-34.66235,2.20741-52.02513,1.9841-9.45528-.02623-18.33669-1.59031-27.48183-2.859,8.89543,2.68164,17.78774,5.58372,27.02553,6.828,18.25028,2.73263,36.77763,2.29226,55.155,3.49163,22.94545,1.8415,45.87082,4.07376,68.87238,5.13148,20.85009.77849,41.72251.32669,62.57087,1.13782,11.82669.44791,23.65926.61155,35.49392.6003C750.39005,448.4564,748.44776,448.0975,746.50583,447.74086Z"
              transform="translate(-362.48127 -285.3078)"
            />
            <path
              d="M726.27569,488.24287c-40.834-8.86452-82.62594-12.1803-124.31434-13.70013-14.227-.04841-28.42042,1.42225-42.65089,1.17807-15.98693-.44158-31.93023-2.102-47.8318-3.7371,15.76026,4.3742,31.7117,8.35219,47.91423,10.68532,13.27526,1.8802,26.69581,1.84825,40.06822,2.26992,13.38384.59977,26.744,1.692,40.13316,2.18654,14.11687.36885,28.2417.385,42.362.5615,15.22.12737,30.4259.862,45.64448,1.07574C730.09618,488.89823,727.42866,488.51449,726.27569,488.24287Z"
              transform="translate(-362.48127 -285.3078)"
            />
            <path
              d="M731.70615,527.79166c-12.72337-2.71982-36.33882-4.76764-42.02193-5.7432-18.47471-2.48284-36.88067-6.05985-55.56249-6.48715-20.44643-.51578-40.86324,1.01946-61.26032,2.21919-19.4145.909-38.84979,1.40519-58.28092,1.76495a519.75827,519.75827,0,0,0,58.51141,6.682c20.44124.96093,40.90515.09559,61.3528.40219,16.49709.34582,32.89272,2.3611,49.365,3.14062,14.53352.83157,29.07656-.08,43.61579-.1155,4.39144-.00849,8.78408-.0142,13.17465-.066C737.63811,528.97736,734.675,528.36988,731.70615,527.79166Z"
              transform="translate(-362.48127 -285.3078)"
            />
            <path
              d="M422.05335,340.25359a83.27067,83.27067,0,0,0-9.071-.48262c.10944-7.71484-.13923-15.44033-.53926-23.13984a115.03663,115.03663,0,0,0-2.68414,23.14347c-3.13352.02788-6.2686.09854-9.3997.05914-5.56813.00753-11.098-.73667-16.65088-1.03556,6.73721,2.51262,13.61693,4.76323,20.8139,5.43418,1.749.16148,3.50186.25924,5.25608.33171a117.72117,117.72117,0,0,0,1.71716,17.17809c.7422-5.67393,1.16768-11.3735,1.37012-17.08311,7.442.12157,14.91-.3724,22.32395-.81381,1.29479-.115,2.58907-.25352,3.88023-.397A117.07735,117.07735,0,0,0,422.05335,340.25359Z"
              transform="translate(-362.48127 -285.3078)"
            />
          </svg>
          <span className="mt-8  font-sans font-medium text-gray-700 text-sm">
            You don't have any interviews yet.
          </span>
          <button
            onClick={() => onCreateInterview()}
            className="mt-6 font-sans font-semibold text-white text-xs px-4 py-2 rounded-full bg-blue-600 hover:bg-blue-700"
          >
            New interview
          </button>
        </div>
      )}
    </div>
  );
};

export default InterviewsCard;
